import axios from 'axios'
import User from 'src/models/User'

class ApiConnector {
  constructor () {
    let user = new User()
    if (user.isUserAuth()) {
      this.axios = axios.create({
        baseURL: process.env.API_URL,
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + user.getAccessToken()
        }
      })
    }
  }

  request (method, url, data) {
    return this.axios({
      method: method,
      url: url,
      data: this._prepareRequestData(data)
    })
  }

  _prepareRequestData (data) {
    return data
  }
}
export default ApiConnector



// WEBPACK FOOTER //
// ./src/helpers/ApiConnector.js